import { useOAuthConfig as e } from "../OAuthConfigContext.mjs";
import { useOAuthLoginMutation as t } from "../useOAuthLoginMutation.mjs";
import { acquireAppleCredential as n } from "./sdk/appleCredential.mjs";
import { setupGoogleButton as r } from "./sdk/googleButton.mjs";
import { useCallback as i, useRef as a } from "react";
//#region src/web/useOAuthLogin.ts
function o(o = {}) {
	let s = e(), c = o.googleClientId ?? s.googleClientId, l = o.appleClientId ?? s.appleClientId, u = o.appleRedirectURI ?? s.appleRedirectURI, d = t(), { onSuccess: f, onError: p } = o, m = i(async (e) => {
		try {
			let t = await d.mutateAsync(e);
			f?.(t);
		} catch (e) {
			p?.(e);
		}
	}, [
		d,
		f,
		p
	]), h = a(null);
	return {
		setupGoogle: i(async (e, t) => {
			!c || !e || (h.current = await r({
				clientId: c,
				container: e,
				autoPrompt: t?.autoPrompt,
				onCredential: (e, t) => void m({
					provider: "google",
					credential: e,
					nonce: t
				}),
				onError: p
			}));
		}, [
			c,
			m,
			p
		]),
		cancelGoogle: i(() => {
			h.current?.cancel();
		}, []),
		signInWithApple: i(async () => {
			if (l) try {
				let { credential: e, nonce: t, appleUser: r } = await n({
					clientId: l,
					redirectURI: u
				});
				await m({
					provider: "apple",
					credential: e,
					nonce: t,
					appleUser: r
				});
			} catch (e) {
				if (e?.error === "popup_closed_by_user") return;
				p?.(e);
			}
		}, [
			l,
			u,
			m,
			p
		]),
		googleEnabled: !!c,
		appleEnabled: !!l,
		isPending: d.isPending,
		error: d.error
	};
}
//#endregion
export { o as useOAuthLogin };
